import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appResizeObserver]',
})
export class ResizeObserverDirective implements OnInit, OnDestroy {
  private reObs: ResizeObserver | null = null;
  private lastW = 0;
  private lastH = 0;
  private lastX = 0;
  private lastY = 0;

  @Input() appResizeObserver: undefined;
  @Output() readonly appResizeEvent = new EventEmitter<{ x: number; y: number; w: number; h: number }>();

  // eslint-disable-next-line no-unused-vars
  constructor(private readonly element: ElementRef) {}

  public async ngOnInit(): Promise<void> {
    const observerOptions: ResizeObserverOptions = {
      box: 'border-box',
    };

    this.reObs = new ResizeObserver(() => this.onResize());
    if (this.reObs == null) {
      throw new Error('[ResizeObserver] Initialization failed');
    }

    this.reObs.observe(this.element.nativeElement, observerOptions);
  }

  ngOnDestroy(): void {
    if (this.reObs) this.reObs.disconnect();
  }

  private onResize(): void {
    const w = this.element.nativeElement.clientWidth;
    const h = this.element.nativeElement.clientHeight;
    const x = this.element.nativeElement.offsetLeft;
    const y = this.element.nativeElement.offsetTop;

    if (w === this.lastW && h === this.lastH && x === this.lastX && y === this.lastY) {
      return;
    }

    this.lastW = w;
    this.lastH = h;
    this.lastX = x;
    this.lastY = y;

    if (w + h > 0) {
      this.appResizeEvent.next({ w, h, x, y });
    }
  }
}
